import React from 'react'

export default function Client() {
  return (
    <div>
      <div className="container-fluid clint1 mt-5" style={{
        maxWidth:'1440px',
      }}>
        <div className="container-fluid clint2 pt-5" style={{
        maxWidth:'1280px'
      }}>
<div className="row text-center">
    <h1 className='clinth1 sora' style={{fontWeight:'400'}}>Our clients show their <span style={{
      fontWeight:'800'
    }}>Experiences</span></h1>
</div>
<div className="row  client4" style={{
    paddingTop:'40px', paddingBottom:'40px'
}}>
    <div className="col-lg-4 pt-4">
    <div className="card clint3" style={{boxShadow: '0 4px 10px rgba(0, 0, 0, 0.5)' ,alignItems:'center', textAlign:'center', borderRadius:'20px', gap:'15px'}}>
  <div className="card-body">
    <img  src="/images/Frame 18.png" alt="" />
    <p className="card-text mt-3 sora clenitpp" style={{ fontWeight:'400', color:'#404040'}} >I recently had to jump on 10+ different calls across eight different countries to find the right owner.</p>
    <h5 className="card-title mt-3 soraclenithh" style={{
    borderWidth: '1px',
    borderTop: '3px solid black',
    paddingTop: '10px',
    fontWeight: '600',
    display: 'inline-block' // This limits the width of the border to the text
}}>
  Evren Shah
</h5>
    <p className='mt-3 mb-0 pb-0 sora clenitpp' style={{ fontWeight:'600', color:'#404040'}}>Desginer</p>
  </div>
</div>
    </div>
    <div className="col-lg-4 pt-4 ">
    <div className="card clint3" style={{boxShadow: '0 4px 10px rgba(0, 0, 0, 0.5)' ,alignItems:'center', textAlign:'center', borderRadius:'20px', gap:'15px', backgroundColor:'black'}}>
  <div className="card-body">
    <img  src="/images/Frame 18 (1).png" alt="" />
    <p className="card-text mt-3 text-white sora clenitpp"  style={{ fontWeight:'400'}}>I recently had to jump on 10+ different calls across eight different countries to find the right owner.</p>
    <h5 className="card-title mt-3 text-white sora clenithh" style={{  borderWidth: '1px',
    borderTop: '3px solid white',
    paddingTop: '10px',
    fontWeight: '600',
    display: 'inline-block'}}>Flora Sheen</h5>
    <p className='mt-3 mb-0 pb-0 text-white sora clenitpp'  style={{ fontWeight:'600'}}>Desginer</p>
  </div>
</div>
    </div>
    <div className="col-lg-4 pt-4">
    <div className="card clint3" style={{boxShadow: '0 4px 10px rgba(0, 0, 0, 0.5)' ,alignItems:'center', textAlign:'center', borderRadius:'20px', gap:'15px',}}>
  <div className="card-body ">
    <img  src="/images/Frame 18.png" alt="" />
    <p className="card-text mt-3 sora clenitpp" style={{ fontWeight:'400', color:'#404040'}} >I recently had to jump on 10+ different calls across eight different countries to find the right owner.</p>
    <h5 className="card-title mt-3 soraclenithh" style={{
    borderWidth: '1px',
    borderTop: '3px solid black',
    paddingTop: '10px',
    fontWeight: '600',
    display: 'inline-block' // This limits the width of the border to the text
}}>
  Evren Shah
</h5>
    <p className='mt-3 mb-0 pb-0 sora clenitpp'  style={{ fontWeight:'600', color:'#404040'}}>Desginer</p>
  </div>
</div>
    </div>
</div>
        </div>
      </div>
    </div>
  )
}
